import { render, staticRenderFns } from "./Step3ThirdParty.vue?vue&type=template&id=318dc38e&scoped=true"
import script from "./Step3ThirdParty.vue?vue&type=script&lang=js"
export * from "./Step3ThirdParty.vue?vue&type=script&lang=js"
import style0 from "./Step3ThirdParty.vue?vue&type=style&index=0&id=318dc38e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318dc38e",
  null
  
)

export default component.exports